module.exports = __webpack_public_path__ + "media/images/admin/favicons/site-92da0b25e36381c7ae3ce318d7bec4e0.webmanifest";